define( [
	"./document"
], function( document ) {
	"use strict";

	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./~/_jquery@3.6.0@jquery/src/var/documentElement.js
// module id = 186
// module chunks = 0